"use client";

import { c as _c } from "react/compiler-runtime";
import { useForm } from "@tanstack/react-form";
import { redirect } from "next/navigation";
import { useAlertContext } from "@/providers/context.provider";
import { ForgotPasswordComponent } from "@/components/custom/auth/forgotPassword";
import { forgotPassword } from "@/services/auth.service";
import type { TForgotPasswordForm } from "@/types/auth.type";
export const ForgotPasswordContainer = () => {
  const $ = _c(5);
  const {
    showAlert
  } = useAlertContext();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      email: ""
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== showAlert) {
    t1 = {
      defaultValues: t0,
      onSubmit: async t2 => {
        const {
          value
        } = t2;
        const {
          email
        } = value;
        const resp = await forgotPassword(email);
        if (resp) {
          redirect(`/resendForgetPassword?email=${email}`);
          return;
        }
        showAlert("Email does not exist", false);
      }
    };
    $[1] = showAlert;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const form = useForm(t1);
  let t2;
  if ($[3] !== form) {
    t2 = <ForgotPasswordComponent form={form} />;
    $[3] = form;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};